<template>
    <div class="product-list">
        <div class="mains">
             <div class="bg" :style="{'background':$abctheme.basecolor,width:'100%',height:'100%'}">
            </div>
            <div class="headerlogo">
                <div class="maininfo">
                    <div class="headerinfo">
                        <div class="sinfo">
                            <div class="slogo">
                                <img src="../../../assets/images/sslogo.png">
                            </div>
                            <span>群婴汇商城 | </span>
                            <span>积分余额:{{abp.userInfo.integral}}</span>
                        </div>
                    </div>
                    <van-sticky>
                        <div class="headerinfo">
                            <div class="ssinfo">
                                <!-- <div class="search">
                                    <div>
                                        <van-icon  class="msearch-mg-icon" :size="12" name="search" />
                                    
                                        群婴汇环腰裤 
                                    </div>
                                </div> -->
                                <div class="search">
                                    <van-search  shape="round" v-model="queryparams.name" @search="search" placeholder="群婴汇环腰裤" />
                                </div>
                            </div>
                        </div>
                        <div class="headerinfo">
                            <div class="cclist">
                                <span @click="onFilterBar(0)" :class="active==0?'active':''">综合</span>
                                <span @click="onFilterBar(1)" :class="active==1?'active':''">销量</span>
                                <!-- <span @click="onFilterBar(2)" :class="active==2?'active':''">新品</span> -->
                                <span @click="onFilterBar(3)" :class="active==3?'active sp ac':'sp ac'">
                                    价格
                                    <van-icon class="righttop" :size="jsize" :color="setpricolor(1)" class-prefix="abc-icon"   name="shang1" />
                                    <van-icon class="rightbtm" :size="jsize" :color="setpricolor(2)" class-prefix="abc-icon"   name="xia1" />
                                </span>
                                <span class="cclist-lls" @click="changell()">
                                    <van-icon  :size="jsize" v-if="ll==1"  class-prefix="abc-icon"   name="liebiao2" />
                                    <van-icon  :size="jsize" v-if="ll==2"  class-prefix="abc-icon"   name="liebiao1" />
                                </span>
                                <div class="cclist-right" @click="showsheet=true">
                                    <van-icon class="ii" :size="jsize" color="#925b2f" class-prefix="abc-icon"   name="liebiao" />
                                    宝贝分类
                                </div>
                            </div>
                        </div>
                    </van-sticky>

                   <van-action-sheet v-model="showsheet" cancel-text="取消" 
                   close-on-click-action close-on-popstate lock-scroll description="选择分类" safe-area-inset-bottom @cancel="showsheet=false" 
                   :actions="actions" @select="onSelect" />

                </div>
            </div>
            <div class="mainlist">
                <div class="infoff">
                    <!-- <van-pull-refresh  v-model="refreshing" @refresh="onRefresh"> -->
                        <van-list
                            v-model="queryparams.loaded"
                            :finished="queryparams.loadingType=='nomore'?true:false"
                            :finished-text="queryparams.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                            @load="loaddata">
                                <div v-if="ll==1">
                                    <div class="infolist"   v-for="(product,i) in products" :key="i"  @click.stop="godetail(product)">
                                        <div class="infolist-pic">
                                            <img :src="$baseurl+product.productImageUrl">
                                        </div>
                                        <div class="infolist-dd">
                                            <div class="infolist-info">
                                                <div class="infolist-info-tit">{{product.title}}</div>
                                                <div v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor}">
                                                    【海外产品】
                                                </div>
                                                <div class="infolist-info-cm">{{product.skus.length>1?'多':'单'}}尺码可选</div>
                                                <div class="infolist-footer">
                                                    <span class="infolist-price"><span style="font-size:14px">积分</span>{{product.price}}</span> 
                                                    <!-- <span class="infolist-smtt">{{product.rSaleNum}}万人付款</span> -->
                                                    <van-icon class="iicart" :size="28" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="ai66" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="ll==2">
                                    <div class="myinfot"   v-for="(product,i) in products" :key="i" @click.stop="godetail(product)" >
                                        <div class="myinfot-pic">
                                            <img :src="$baseurl+product.productImageUrl">
                                        </div>
                                        <div class="myinfot-dd">
                                            <div class="myinfot-info">
                                                <div class="myinfot-info-tit">{{product.title}}</div>
                                                <div v-if="product.isSeaProduct" :style="{color:$abctheme.basecolor}">
                                                    【海外产品】
                                                </div>
                                                <div class="myinfot-info-cm">{{product.skus.length>1?'多':'单'}}尺码可选</div>
                                                <div class="myinfot-footer">
                                                    <span class="myinfot-price"><span style="font-size:14px">积分</span>{{product.price}}</span> 
                                                    <!-- <span class="myinfot-smtt">{{product.rSaleNum}}万人付款</span> -->
                                                    <van-icon class="myinfot-iicart" :size="28" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="ai66" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                

                                <!-- <div v-if="ll==2">
                                    <div class="infolistmore"   v-for="(product,i) in products" :key="i">
                                        <div class="infolistmore-pic">
                                            <img :src="$baseurl+product.productImageUrl">
                                        </div>
                                        <div class="infolistmore-dd">
                                            <div class="infolistmore-info">
                                                <div class="infolistmore-info-tit">{{product.title}}</div>
                                                <div class="infolistmore-info-cm">{{product.skus.length>1?'多':'单'}}尺码可选</div>
                                                <div class="infolistmore-footer">
                                                    <span class="infolistmore-price">{{product.price}}</span> 
                                                    <span class="infolistmore-smtt">{{product.rSaleNum}}万人付款</span>
                                                    <van-icon class="infolistmore-iicart" :size="28" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="ai66" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->

                        </van-list>
                     <!-- </van-pull-refresh> -->
                </div>
            </div>

        </div>

        <retailfooter></retailfooter>
    </div>
</template>

<script>
import searchtop from "../../../components/search/searchtop";

export default {
  components: {
    searchtop
  },
  data() {
    return {
     jsize:15,
      queryparams:{
          loaded:false,
          loadingType: 'more',
          name: "",
          sku:"",
          ProductType:undefined,
          productSku: "",
          sorting: "",
          maxResultCount: 10,
          skipCount: 0,
          categoryId:0,
          filterindex:0,
          isIntegral:true
      },
      refreshing:false,
      products:[],
      value: "",
      filterindex: 0,
      filtersort: false,
      filtershow: false,
      active:0,
      ischeck:1,
      filtershow:false,
      showsheet:false,
      actions:[],
      ll:1,
      nextlevel:undefined,
      sactive:1
    };
  },
  created(){
      var params= this.$route.query;
      if(params.name)
      {
          this.queryparams.name=params.name;
          //设置头部搜索值为对应值
      }
      this.$nextTick(()=>
      {
          this.$refs.search.value=this.queryparams.name;
      })
      //获取这个人下一个等级和下一个等级的价格
     this.ajax.post('/api/services/app/PhoneUser/QueryNextLevel').then(x => {
         this.nextlevel=x.result;
         if(!this.nextlevel)
         {
             this.sactive=2;
         }
    })
      this.ll=localStorage.getItem('orderbymethod') || 1;
      this.loaddata();
      //获取所有分类
      this.querycate();
  },
  methods: {
    setname()
    {
        if(this.nextlevel)
        {
            return  this.abp.userInfo.memberLevelModel.name;
        }
        return '';
    },
    setnextname(){
        if(this.nextlevel)
        {
            return  this.nextlevel.name;
        }
        else
        {
            return  this.abp.userInfo.memberLevelModel.name;
        }
    },
    curprice()
    {
        this.sactive=1;
        this.queryparams.nextLevelPrice=false;
        this.loaddata('refresh');
    },
    nextprice()
    {
        this.sactive=2;
        this.queryparams.nextLevelPrice=true;
        this.loaddata('refresh');
    },
    godetail(item)
    {
        
        var productsku=item.productSku;
        this.$router.push({path:'/product/'+productsku});
    },
    changell(){
        this.ll=this.ll==1?2:1;
        localStorage.setItem('orderbymethod',this.ll);
        console.log(this.ll);
    },
    onSelect(action,index){
        var cateid=action.id;
        this.queryparams.categoryId=cateid;
        this.loaddata('refresh');
    },
    querycate(){
         this.ajax.post('/api/services/app/PhoneCom/QueryCateList',{}).then(x => {
                this.actions=x.result.items;
                this.actions.unshift({name:'全部',id:0});
        })
    },
    search(value){
        
        this.loaddata('refresh');
    },
    openfiter(){
        this.filtershow=true;
    },
    setpricolor(num){

        var color="white";

        if(this.active==3)
        {
            if(this.ischeck==num)
            {
                return this.$abctheme.basecolor;
            }
            color="#595757";
        }
        return color;

    },
    onFilterBar(value) {
        if(this.active==3&&value==3)
        {
            this.ischeck=this.ischeck==1?2:1;
        }
        else
        {
            if(this.active!=3&&value==3)
            {
                this.ischeck=1;
            }
        }
        
        this.active=value;
this.queryparams.isNewP=undefined;
        if(this.active==3&&this.ischeck==1) //价格最小
        {
             this.queryparams.sorting=" UserPrice asc,id desc";
        }
        if(this.active==3&&this.ischeck==2) //价格最大
        {
          this.queryparams.sorting=" UserPrice desc,id desc"; 
        }
        if(this.active==1) //销量
        {
          this.queryparams.sorting="  BaseSaleNum+RealSaleNum desc,id desc"; 
        }
        if(this.active==2) //新品
        {
            // this.$toast.success({message:'暂未实现'});
            // return ;
           this.queryparams.isNewP=true;
        }
        if(this.active==0)
        {
            this.queryparams.sorting="";
        }
        this.loaddata('refresh');
    },
    showProduct(product){
        this.$router.push('/product/'+product.id);
    },
    onRefresh()
    {
        this.loaddata('refresh');
    },
    loaddata(source)
    {
        // if (this.queryparams.loaded === true) {
        //     //tab切换只有第一次需要加载数据
        //     return;
        // }
        if (this.queryparams.loadingType === 'loading' || this.queryparams.loadingType === 'nomore') {
            //防止重复加载
            if(source != 'refresh')
            {
                return;
            } 
        }
        if (source == 'refresh') {
            this.products = [];
            this.queryparams.skipCount = 0;
        }
        this.queryparams.loadingType = 'loading';
        //加载数据
        this.ajax.post('/api/services/app/PhoneCom/QueryProductList', this.queryparams).then(x => {
            this.queryparams.skipCount += this.queryparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.products = this.products.concat(x.result.items);
            console.log(this.products);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.queryparams.loadingType = totalcount > (this.queryparams.skipCount) ? 'more' :'nomore';
        }).finally(()=>
        {
                this.queryparams.loaded=false;
                this.refreshing=false;
        });
    },
    clearname()
    {
      this.queryparams.name='';
    },
    doSearch(name)
    {
        this.queryparams.name=name;
        this.loaddata('refresh');
    },
    navtodetail(item)
    {
          //console.log(this.$router);
          var productsku=item.productSku;
          this.$router.push({path:'/product/'+productsku});
    },
  }
};
</script>

<style lang="scss" scoped>
body{
    background-color: #eeeeee;
}
.mains
{
    font-size: 0.3rem;
}
.bg{
    position: absolute;
    top: -25px;
}
.bg img
{
    width: 100%;
}
.headerinfo{
    position: relative;
    
}
.maininfo{
    padding: 10px 10px 0px 10px;
    color:white;
}
.sinfo{
    padding-left:53px;
    min-height: 60px;
    line-height: 60px;
    font-size: 16px;
    letter-spacing: 2px;
    font-weight: bold;
}
.slogo{
    position: absolute;
    height: 20px;
    width: 20px;
    padding: 10px;
    left: 0;
    top: 50%;
    border-radius: 50%;
    background-color: white;
    transform: translate(0,-50%);
}
.slogo img{
    width: 30px;
    height: auto;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.ssinfo{
    padding-left: 200px;
    min-height: 30px;
    line-height: 30px;
}
.search{
    position: absolute;
    left: 0;
    width: 160px;
}
.sstit .sswz{
    font-size: 16px;
}

.sswz{
    margin-left: 43px;
    position: absolute;
    right: 0;
    bottom: 0;
}
.sactive
{
    font-size: 20px;
    font-weight: bold;
    vertical-align: top;
}
.cclist{
    margin-top:15px;
    line-height: 25px;
}
.cclist span{
    padding: 3px 13px 3px 13px;
    font-size: 14px;
}
.cclist .active{
    border-radius: 8px;
    color: #595757;
    background-color: white;
}

.sp{
    position: relative;
}
.cclist .ac{
    padding-right: 17px;
}
.righttop{
    position:absolute;
    right: 5px;
    top: -5px;
}
.rightbtm{
    position:absolute;
    right: 5px;
    bottom: -5px;
}
.main-list{
    margin: 10px;
}
.main-list-product{
    margin-bottom: 10px;
    padding: 2px;
}
.cclist-lls{
    padding: 0;
    padding-left:10px;
    vertical-align: middle;
}
.cclist-right{
    position: absolute;
    top: -2px;
    right: 0;
    border-radius: 10px;
    background-color: #faf4f7a3;
    color: #595757;
    padding: 2px 6px 2px 6px;
    font-size: 12px;
}


.ii{
    vertical-align: middle;
}

.infoff{
    padding: 15px 10px 10px 10px;
    background-color: #FDD108;
}
.infolist{
    position: relative;
    padding-left: 148px;
    background-color: white;
    min-height: 148px;
    border-radius: 8px;
    margin-bottom: 10px;
}
.infolist-pic{
    position: absolute;
    left:0;
    width: 148px;
    height: 148px;
}
.infolist-pic img{
    width: 100%;
    height: 100%;
    border-radius: 8px 0px 0px 8px;
}
.infolist-dd{
    min-height: 148px;
    position: relative;
}
.mainlist{
   position: relative;
}
.infolist-info{
    padding: 10px 10px 10px 20px;
}
.infolist-info-tit{
    color: #595757;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 1px;
    margin-bottom: 6px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.infolist-info-cm{
    font-size: 12px;
    color: #9b6933;
}
.infolist-footer{
    position: absolute;
    bottom: 12px;
    left: 14px;
    right: 0;
}
.infolist-price::before{
    position: absolute;
    left: 0;
}
.infolist-price{
    color: #ff5c2e;
    font-weight: bold;
    font-size: 20px;
    position: relative;
}

.infolist-smtt{
    font-size: 12px;
    margin-left: 5px;
}
.iicart{
    position:absolute;
    right: 18px;
}
.myinfot{
    background-color:white;
    padding:5px;
    border-radius:4px;
    display: inline-block;
    width: 46%;
    margin-bottom: 10px;
    height: 250px;
}
.myinfot:nth-child(even){
    float: right;
}
.myinfot-pic{
    width: 100%;
}
.myinfot-pic img{
    width: 100%;
}
.myinfot-dd{
    margin-top: 5px;
    padding-left:10px;
}
.myinfot-info{
   min-height: 80px;
   position: relative;
}
.myinfot-info-tit{
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
   word-break: break-all;
   overflow: hidden;
}
.myinfot-info-cm{
    font-size: 10px;
    color:#9b6933;
}
.myinfot-smtt{
     font-size: 10px;
    margin-left: 5px;
}
.myinfot-footer{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
}
.myinfot-price::before{
    position: absolute;
    left: -7px;
}
.myinfot-price{
    margin-right: 10px;
    font-size: 18px;
    color: red;
}
.myinfot-iicart{
    position: absolute;
    right: 0;
    bottom: -5px;
}
.search .van-search{
    padding: 0;
    background-color:transparent;
}
.search .van-search__content--round{
    border-radius: 5px;
    background-color: #FEE46A;
    padding-left: 30px;
}
</style>

<style lang="scss">

.maininfo .van-sticky--fixed{
    padding: 10px;
    background-color: #FDD108;
}
</style>